module.exports = __webpack_public_path__ + "img/saderat.ae88187a.png";